module.exports = __webpack_public_path__ + "img/dynamo-kyiv-logo-icon.bd067883.png";